// @ts-nocheck
/* eslint-disable */
export const llaPlatformClockIcon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.5 16C30.5 24.0081 24.0081 30.5 16 30.5C7.99187 30.5 1.5 24.0081 1.5 16C1.5 7.99187 7.99187 1.5 16 1.5C24.0081 1.5 30.5 7.99187 30.5 16Z" stroke="currentColor" stroke-width="1.5"/><path d="M16 8V16L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
    name: 'clock' as const
};